'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import H4 from 'UIComponents/elements/headings/H4';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.themes.emptyState.${key}`;
export const EmptyState = ({
  assetType,
  isError = false
}) => {
  return isError ? /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "badRequest",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('error')
    })
  }) : /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "empty-state-charts",
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`empty.title.${assetType}`)
      })
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('empty.message')
    })
  });
};